<!-- 公共组件--查看短信内容 -->
<template>
  <div>
    <div
      class="mobile-box"
      :style="{ background: 'url(' + mobileScreen + ') no-repeat' }"
    >
      <div class="sms-center" v-loading="loading">
        <div v-if="form.type == 1">
          <el-image :src="mulitiFileList[0]"  :preview-src-list="mulitiFileList" alt="" width="216" :z-index="99999"></el-image>
          <div class="bggray">
            <div class="title">{{ form.title }}</div>
            <div class="content">{{ form.text }}</div>
            <div class="btn-box">
              <div class="btn" v-for="item in form.btnConfig.btnArray">
                {{ item.btnName }}
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="form.type == 2">
          <video
            style="max-width: 216px; border-radius: 6px 6px 0 0"
            controlslist="nodownload"
            ref="curVideo"
            preload="auto"
            controls="controls"
            v-if="mulitiFileList[0]"
          >
            <source :src="mulitiFileList[0]" type="video/mp4" />
          </video>
          <div class="bggray">
            <div class="title">{{ form.title }}</div>
            <div class="content">{{ form.text }}</div>
            <div class="btn-box">
              <div class="btn" v-for="item in form.btnConfig.btnArray">
                {{ item.btnName }}
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="form.type == 3">
          <div class="card-carousel" style="width: 218px;height: 122px;">
            <el-carousel height="122px" indicator-position="none" arrow="never" :interval="1000">
              <el-carousel-item v-for="(item, index) in mulitiFileList" :key="'mulitiFileList'+index">
                <el-image 
                  style="width: 100%; height: 100%" 
                  :src="item" 
                  :preview-src-list="mulitiFileList" 
                  :initial-index="index"
                  :fit="'cover'"
                  :z-index="99999">
              </el-image>
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="bggray">
            <div class="title">{{ form.title }}</div>
            <div class="content">{{ form.text }}</div>
            <div class="btn-box">
              <div class="btn" v-for="item in form.btnConfig.btnArray">
                {{ item.btnName }}
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="form.type == 4">
          <div class="redEnvelope">
            <el-image class="packetIcon" :src="mulitiFileList[0]" :preview-src-list="mulitiFileList"
              :z-index="99999">
            </el-image>
            <div class="packetText">
              <div class="redNameText">{{  form.redName }}</div>
              <div class="editText" style="font-size: 16px;">
                {{ form.title }}
              </div>
              <div class="describeText">
                {{ form.text }}
              </div>
            </div>
            <div class="btn-list" style="position: absolute;bottom: 24px; left: 0; right: 0; margin: auto;">
              <div class="btn">{{ form.btnConfig.btnArray[0].btnName }}</div>
            </div>
          </div>
        </div>
        <div v-else-if="form.type == 5">
          <div v-if="form.goodsCard == 1" class="card-carousel" style="width: 218px;height: 122px;">
            <el-carousel height="122px" indicator-position="none" arrow="never" :interval="1000">
              <el-carousel-item v-for="(item, index) in mulitiFileList" :key="'mulitiFileList'+index">
                <el-image 
                  style="width: 100%; height: 100%" 
                  :src="item" 
                  :preview-src-list="mulitiFileList" 
                  :initial-index="index"
                  :fit="'cover'"
                  :z-index="99999">
              </el-image>
              </el-carousel-item>
            </el-carousel>
          </div>
          <video
            style="max-width: 216px; border-radius: 6px 6px 0 0"
            controlslist="nodownload"
            ref="curVideo"
            preload="auto"
            controls="controls"
            v-if="form.goodsCard == 2 && mulitiFileList[0]"
          >
            <source :src="mulitiFileList[0]" type="video/mp4" />
          </video>
          <div class="bggray">
            <div class="price-box">
              <div class="price">
                <span v-if="form.displaySymbol">￥</span>
                <span>{{ form.price }}</span>
              </div>
              <div class="label" v-if="form.label">{{ form.label }}</div>
            </div>
            <div class="title">{{ form.title }}</div>
            <div class="content">{{ form.text }}</div>
            <div class="btn-box">
              <div class="btn" v-for="item in form.btnConfig.btnArray">
                {{ item.btnName }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>


import { getCardPreview } from "@/api/backstage/smsCard";

export default {
  components: {
  },
  props: {
    // 卡片模板id
    id: {
      default: "",
    },
    smsInfo:{
      type:Object,
      default: ()=>{
        return {
          name: "",
          type: 1, 
          smsCardFileId: "",
          coverId: "",
          title: "",
          text: "",
          btnConfig: {
            btnCnt: 0,
            btnArray: [
              {
                btnName: "",
                url: "",
              },
            ],
          },
          redName: "", // 红包名称
          price: "",
          label: "",
          displaySymbol: "", // ￥ 0 显示 1 不显示
          goodsCard: "", //商品卡片类型
          mulitiFileList:[],
        }
      },
    }
  },
  data() {
    return {
      mobileScreen: require("@/assets/images/mobileScreen.png"), // 预览图地址
      mulitiFileList:[],// 素材文件
      form:{
        name: "",
        type: 1, 
        smsCardFileId: "",
        coverId: "",
        title: "",
        text: "",
        btnConfig: {
          btnCnt: 0,
          btnArray: [
            {
              btnName: "",
              url: "",
            },
          ],
        },
        redName: "", // 红包名称
        price: "",
        label: "",
        displaySymbol: "", // ￥ 0 显示 1 不显示
        goodsCard: "", //商品卡片类型
      },
      loading:false,
    };
  },
  created() {},
  mounted() {
    this.loading = true;
    if (this.id) {
      getCardPreview(this.id).then((res) => {
        console.log('res',res);
        if(res.code == 1){
          this.mulitiFileList = res.data.mulitiFileList.map(item=>{
            return item.mulitiFileDatas.fileUrl
          });
          Object.assign(this.form,res.data)
        }else{
          this.$message.error(res.message);
        }
        this.loading = false;
        
      });
    }
  },
  methods: {
  },
};
</script>

<style lang="scss" scoped>
.mobile-box {
  position: relative;
  width: 256px;
  height: 504px;

  .sms-center {
    overflow: auto;
    // width: 244px;
    height: 335px;
    padding: 0 20px;
    position: relative;
    top: 93px;
    left: 0;

    &::-webkit-scrollbar {
      display: none;
    }
  }
  .bggray {
    background: #f5f5f5;
    border-radius: 0px 0px 6px 6px;
    padding: 10px 8px 12px 8px;
    .title {
      height: 17px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #333333;
      line-height: 22px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .content {
      font-weight: 400;
      font-size: 10px;
      color: #999999;
      line-height: 16px;
      margin: 10px 0;
    }
    .price-box{
      display: flex;
      margin-bottom: 10px;
      .price{
        font-weight: 400;
        font-size: 12px;
        color: #FE4D45;
        line-height: 22px;
      }
      .label{
        margin-left: 6px;
        padding: 0 4px;
        background: #FE4D45;
        border-radius: 2px 2px 2px 2px;
        font-weight: 400;
        font-size: 10px;
        color: #FFFFFF;
        line-height: 22px;
      }
    }
    .btn-box{
      display: flex;
      .btn{
        flex: 1;
        height: 24px;
        padding: 0;
        line-height: 22px;
        background: #278CFE;
        border-radius: 2px 2px 2px 2px;
        font-weight: 400;
        font-size: 12px;
        color: #FFFFFF;
        text-align: center;
      }
      .btn + .btn{
        margin-left: 10px;
      }
    }
  }
  
}
.redEnvelope{
  width: 218px;
  height: 280px;
  background: url('~@/assets/images/backstage/redBag.png') no-repeat;
  background-size: 100% 100%;
  position: relative;
  .packetIcon{
    width: 52px;
    height: 52px;
    position: absolute;
    left: 85px;
    top: 55px;
    border-radius: 50%;
  }
  .packetText {
    position: absolute;
    color: white;
    width: 100%;
    text-align: center;
    top: 120px;
  }
  .btn {
    width: 142px;
    height: 24px;
    background: #FBA704;
    border-radius: 2px 2px 2px 2px;
    font-weight: 400;
    font-size: 10px;
    color: #FFFFFF;
    text-align: center;
    margin: 0 auto;
    line-height: 22px;
  }

}
.redEnvelope .packetText .redNameText{
  font-size: 12px;
  color: #FFFFFF;
  line-height: 22px;
  text-align: center;
}
.redEnvelope .packetText .editText{
  font-size: 14px;
  color: #FFFFFF;
  line-height: 22px;
  text-align: center;
}
.redEnvelope .packetText .describeText{
  font-size: 10px;
  color: #FFFFFF;
  line-height: 22px;
  text-align: center;
}


</style>
